import React, { forwardRef } from 'react';
import styles from './index.modules.scss';
import { Icon } from '@shakkerai/components';

export const Text = forwardRef((props, ref) => {
  const {
    iconClass,
    children,
    size = 14,
    fSize,
    iSize,
    color,
    direction = 'row',
    fw = 400,
    style,
    className,
    ...resetProps
  } = props;

  let innerSize = size;
  // 兼容外部透传属性时，size属性丢失问题
  if (fSize) {
    innerSize = fSize;
  }

  const innerStyle = {
    fontSize: innerSize + 'px',
    color: color,
    flexDirection: direction,
    fontWeight: fw,
    ...style,
  };

  if (resetProps.onClick) {
    innerStyle.cursor = 'pointer';
  }

  return (
    <span ref={ref} className={`${styles.text} ${className}`} style={innerStyle} {...resetProps}>
      {iconClass && (
        <Icon
          className={`${iconClass} ${children ? styles.icon : null}`}
          fontSize={iSize || innerSize + 2}
          color={color}
        />
      )}
      {children}
    </span>
  );
});

export const Tip = (props) => {
  const { children, ...rest } = props;
  return (
    <Text {...rest} size={12} color="var(--color-subsidiary-font)">
      {children}
    </Text>
  );
};

export const Title = (props) => {
  return (
    <Text size={22} color="black" fw={700}>
      {props.children}
    </Text>
  );
};
